import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/errorRep.svg'


const _hoisted_1 = { class: "w-screen h-screen overflow-hidden flex justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-60"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-medium text-center" }, "페이지를 찾을 수 없습니다", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "leading-relaxed text-center" }, [
  /*#__PURE__*/_createTextVNode("원하시는 결과를 찾을 수 없습니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 올바른 URL을 입력하셨는지 확인해주세요. "),
  /*#__PURE__*/_createElementVNode("br")
], -1)

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const router = useRouter();
const backToMain = () => {
router.push('/')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex flex-col text-def space-y-8 items-center" }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "w-40 rounded-full text-pada border-pada border border-solid py-3",
        onClick: backToMain
      }, " 메인으로 돌아가기")
    ])
  ]))
}
}

})